<script>
import Layout from "@/views/layouts/default";
import PageHeader from "@/components/page-header";
import Swal from "sweetalert2";
import appConfig from "@/app.config";
import pdf from 'vue-pdf'

/**
 * Advanced table component
 */
export default {
  name: "DriverDetail",
  page: {
    title: "Lihat Driver",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, pdf },
  data() {
    return {
      title: "Lihat Driver",
      items: [
        {
          text: "Manajemen Armada",
        },
        {
          text: "Driver",
          href: "/driver"
        },
        {
          text: "Lihat",
          active: true
        },
      ],
      form: {},
      vaccines: [],
      isSubmitDriverError: false,
      errorMessage: null,
      isSubmitDriverSuccess: false,
      successMessage: null,
      document: {
        type: "",
        src: ""
      },
    };
  },
  created() {
    this.getDetail()
  },
  methods: {
    getDetail() {
      this.$axios.get(`/v1/logistic_company/driver/${this.$route.params.id}`)
        .then(response => {
          console.log(response.data);
          this.form = response.data.data
        })
        .catch(error => {
          if (error.response.status == 404) {
            this.$router.push('/404')
          }
        })
    },
    confirmDelete() {
      Swal.fire({
        title: "Apa Anda yakin akan menghapus data ini ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Batal",
        confirmButtonText: "Ya"
      }).then( async (result) => {
        if (result.value) {
          await this.$axios.delete(`/v1/logistic_company/driver/${this.$route.params.id}`)
          .then(response => {
            this.isSubmitDriverSuccess = true
            this.isSubmitDriverError = false
            this.successMessage = response.data.message
            setTimeout(() => {
              this.$router.push('/driver')
            }, 3000)
          }).catch(error => {
            this.isSubmitDriverSuccess = false
            this.isSubmitDriverError = true
            this.errorMessage = error.response.data.message
          })
        }
      });
    },
    activate() {
      Swal.fire({
        title: "Apa Anda yakin akan mengaktifkan driver ini ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Batal",
        confirmButtonText: "Ya"
      }).then( async (result) => {
        if (result.value) {
          await this.$axios.put(`/v1/logistic_company/driver/${this.$route.params.id}/status`, {
            account_status: 'aktif'
          })
          .then(response => {
            this.isSubmitDriverSuccess = true
            this.isSubmitDriverError = false
            this.successMessage = response.data.message
            this.getDetail()
          }).catch(error => {
            this.isSubmitDriverSuccess = false
            this.isSubmitDriverError = true
            this.errorMessage = error.response.data.message
          })
        }
      });
    },
    disactivate() {
      Swal.fire({
        title: "Apa Anda yakin akan menonaktifkan driver ini ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Batal",
        confirmButtonText: "Ya"
      }).then( async (result) => {
        if (result.value) {
          await this.$axios.put(`/v1/logistic_company/driver/${this.$route.params.id}/status`, {
            account_status: 'tidak aktif'
          })
          .then(response => {
            this.isSubmitDriverSuccess = true
            this.isSubmitDriverError = false
            this.successMessage = response.data.message
            this.getDetail()
          }).catch(error => {
            this.isSubmitDriverSuccess = false
            this.isSubmitDriverError = true
            this.errorMessage = error.response.data.message
          })
        }
      });
    },
    previewDoc(doc) {
      const extention = doc.split(".").pop()
      this.document = {
        type: extention,
        src: doc
      }
      this.$refs.modalDocument.show()
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-alert
              v-model="isSubmitDriverSuccess"
              class="mt-3"
              variant="success"
              dismissible
            >{{ successMessage }}</b-alert>

            <b-alert
              v-model="isSubmitDriverError"
              class="mt-3"
              variant="danger"
              dismissible
            >{{errorMessage}}</b-alert>
            <div class="row">
              <div class="col-lg-4">
                <p class="text-success font-weight-medium mb-0" v-if="form.account_status === 'aktif'">{{ form.account_status | capitalize }}</p>
                <p class="text-danger font-weight-medium mb-0" v-else-if="form.account_status === 'tidak aktif'">{{ form.account_status | capitalize }}</p>
                <p class="text-warning font-weight-medium mb-0" v-else>{{ form.account_status | capitalize }}</p>
                <p class="font-weight-bolder font-size-24 mb-0">
                  {{ form.name }}
                </p>
                <p class="font-weight-medium mb-0">
                  {{ form.email }}
                </p>
              </div>
              <div class="col-lg-4 border-kiri pl-4">
                <label class="mb-0 form-label font-weight-light">Alamat</label>
                <p class="font-weight-bolder mb-0">
                  {{ form.address }}
                </p>
                <label class="mb-0 mt-2 form-label font-weight-light">Telepone</label>
                <p class="font-weight-bolder mb-0">
                  {{ form.phone }}
                </p>
              </div>
              <div class="col-lg-4 border-kiri pl-4">
                <label class="mb-0 form-label font-weight-light">PIC</label>
                <p class="font-weight-bolder mb-0">{{ form.name }} - {{ form.phone }}</p>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col-lg-4" v-if="form.ktp">
                <h5 class="font-weight-semibold">KTP</h5>
                <label class="mb-0 form-label font-weight-light">No KTP</label>
                <p class="font-weight-bolder mb-0">
                  {{ form.ktp.ktp_no }}
                </p>
                <br />
                <label class="mb-0 form-label font-weight-light">Nama</label>
                <p class="font-weight-bolder mb-0">
                  {{ form.ktp.name }}
                </p>
                <br />
                <div class="row">
                  <div class="col-lg-6">
                    <label class="mb-0 form-label font-weight-light">Jenis Kelamin</label>
                    <p class="font-weight-bolder mb-0" v-if="form.ktp.gender == 'L'">Laki-laki</p>
                    <p class="font-weight-bolder mb-0" v-else>Perempuan</p>
                    <br />
                  </div>
                  <div class="col-lg-6">
                    <label class="mb-0 form-label font-weight-light">Tanggal Lahir</label>
                    <p class="font-weight-bolder mb-0">{{ form.dob | date_only }}</p>
                    <br />
                  </div>
                </div>
                <label class="mb-0 form-label font-weight-light">Alamat</label>
                <p class="font-weight-bolder mb-0">
                  {{ form.ktp.address }}
                </p>
                <div class="w-100 d-flex justify-content-between my-3">
                  <b-button variant="outline-danger" type="button" class="w-50 mr-1" @click="previewDoc(form.ktp.ktp_path)">
                    KTP <br />
                    <u>Lihat</u>
                  </b-button>
                  <b-button variant="outline-danger" type="button" class="w-50 mr-1" @click="previewDoc(form.ktp.selfie_ktp_path)">
                    Selfie KTP<br />
                    <u>Lihat</u>
                  </b-button>
                </div>
              </div>
              <div class="col-lg-4 border-kiri pl-4" v-if="form.sim">
                <h5 class="font-weight-semibold">SIM</h5>
                <label class="mb-0 form-label font-weight-light">No SIM</label>
                <p class="font-weight-bolder mb-0">
                  {{ form.sim.sim_no }}
                </p>
                <br />
                <label class="mb-0 form-label font-weight-light">Nama</label>
                <p class="font-weight-bolder mb-0">
                  {{ form.sim.name }}
                </p>
                <br />
                <label class="mb-0 form-label font-weight-light">Tipe SIM</label>
                <p class="font-weight-bolder mb-0">
                  SIM {{ form.sim.type }}
                </p>
                <br />
                <label class="mb-0 form-label font-weight-light">Masa Aktif</label>
                <p class="font-weight-bolder mb-0">
                  {{ form.sim.expired_at | date_only }}
                </p>
                <div class="w-100 d-flex justify-content-between my-3">
                  <b-button variant="outline-danger" type="button" class="w-50 mr-1" @click="previewDoc(form.sim.sim_path)">
                    SIM <br />
                    <u>Lihat</u>
                  </b-button>
                  <b-button variant="outline-danger" type="button" class="w-50 mr-1" @click="previewDoc(form.sim.selfie_sim_path)">
                    Selfie SIM<br />
                    <u>Lihat</u>
                  </b-button>
                </div>
              </div>
              <div class="col-lg-4 border-kiri pl-4">
                <h5 class="font-weight-semibold">Vaksin</h5>
                <div class="row border-radius mx-1 p-2" v-for="(item, index) in form.vaccines" :key="index">
                  <div class="col-lg-8">
                    <label class="mb-0 form-label font-weight-light">No Sertifikat</label>
                    <p class="font-weight-bolder mb-0">
                      {{ item.vaccine_no }}
                    </p>
                  </div>
                  <div class="col-lg-4">
                    <label class="mb-0 form-label font-weight-light">Dosis</label>
                    <p class="font-weight-bolder mb-0">
                      {{ item.dosage || '-' }}
                    </p>
                  </div>
                  <div class="col-lg-12 mt-3">
                    <b-link class="cursor-pointer text-merah" @click="previewDoc(item.vaccine_path)">Lihat Sertifikat</b-link>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col-sm-2">
                <b-button to="/driver" type="button" class="w-100 btn-light">Kembali</b-button>
              </div>
              <div class="col-sm-2">
                <b-button type="button" class="w-100 btn-light" @click="confirmDelete">Hapus</b-button>
              </div>
              <div class="col-sm-2">
                <b-button type="button" variant="danger" class="w-100" @click="$router.push(`/driver/${$route.params.id}/edit`)">Edit</b-button>
              </div>
              <div class="col-sm-2" v-if="form.account_status == 'aktif'">
                <b-button type="button" variant="outline-danger" class="w-100" @click="disactivate">Non Aktifkan</b-button>
              </div>
              <div class="col-sm-2" v-if="form.account_status == 'tidak aktif'">
                <b-button type="button" variant="danger" class="w-100" @click="activate">Aktifkan</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- modal preview document -->
    <b-modal title="Preview" ref="modalDocument" id="modal-document" hide-footer no-close-on-esc no-close-on-backdrop>
      <div class="row">
        <div class="col-lg-12 text-center">
          <b-link :href="document.src" target="_blank">
            <pdf v-if="document.type === 'pdf'" :src="document.src"></pdf>
            <b-img v-else fluid :src="document.src"></b-img>
          </b-link>
        </div>
      </div>
    </b-modal>
    <!-- / modal-->
  </Layout>
</template>